import { useTranslations } from "next-intl";
import React, { FC, useContext, useEffect, useMemo, useRef } from "react";

import { AvailableUnitContext } from "@/context/AvailableUnitListContext";
import { LoadingContext } from "@/context/LoaderContext";

import Icon from "../ui/Icon/Icon";

interface Props {}
const Pagination: FC<Props> = () => {
  const t = useTranslations();
  const { pagination, setPage } = useContext(AvailableUnitContext);
  const pages: number[] = useMemo(() => {
    return Array.from({ length: pagination.total }, (_, i) => i + 1);
  }, [pagination]);
  const { loading } = useContext(LoadingContext);
  const isFirstPage = pagination.current === 1;
  const isLastPage = pagination.current === pagination.total;
  const firstRender = useRef(true);

  return pagination.total > 1 ? (
    <>
      <div className="flex gap-xxs justify-center my-xl">
        <button
          title={t("button.label.previousPage")}
          disabled={isFirstPage}
          className={isFirstPage ? "opacity-30 cursor-not-allowed" : ""}
          onClick={() => {
            loading(true);
            setPage(Math.max(pagination.current - 1, 1));
          }}
        >
          <Icon name="caret-left" size="32" className="stroke-black" />
        </button>
        {pages.map((page, index) => {
          return (
            <button
              onClick={() => {
                loading(true);
                setPage(page);
              }}
              title={t("button.label.goToPage", { page: page })}
              className={`font-secondary font-medium text-s uppercase w-xl flex items-center justify-center aspect-square rounded-full hover:border hover:border-gray-20 ${pagination.current - 1 === index ? "border" : ""}`}
              key={`aul-pagination-${index}`}
            >
              {page}
            </button>
          );
        })}
        <button
          title={t("button.label.nextPage")}
          disabled={isLastPage}
          className={isLastPage ? "opacity-30 cursor-not-allowed" : ""}
          onClick={() => {
            loading(true);
            setPage(Math.min(pagination.current + 1, pagination.total));
          }}
        >
          <Icon name="caret-right" size="32" className="stroke-black" />
        </button>
      </div>
    </>
  ) : (
    <></>
  );
};
export default Pagination;
